import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ShelfTalkersState} from './shelf-talkers.reducer';
import {IStore} from '../../../shared/shared-models/store/store';
import {IAutoOrderAddStockItems} from '../../auto-ordering/models';
import {IPaginationData} from '../../../shared/shared-models/pagination/pagination-data';
import {StockItem} from '../../../shared-utilities/models-old/datastructures';
import {
  selectLineColoursBySelectedStore,
  selectSuppliersByUserSelectedStore,
} from '../../core/store-shared/shared.selectors';
import {ISearchableFields} from '../../../shared/shared-models/type-sense/default-searchable-fields';
import {ISupplier} from '../../../shared/shared-models/stock/suppliers';
import {
  IFirebaseLabelDesignsData,
} from '../../../shared/shared-components/components/shared-label-designer/models/label-interfaces';
import {selectSelectedStore} from '../../user-access/user-stores-store/user-store.selectors';
import {TLineColour} from '../../settings-new/models';

export const selectShelfTalkersState = createFeatureSelector<ShelfTalkersState>('shelf-talkers');


export const selectShelfTalkersStockItems = createSelector(
  selectShelfTalkersState,
  selectSelectedStore,
  (state: ShelfTalkersState, store: IStore): StockItem[] => (state.stockItems[store.storeId] ?? []),
);

export const selectShelfTalkersStockItemsExceptions = createSelector(
  selectShelfTalkersState,
  selectSelectedStore,
  (state: ShelfTalkersState, store: IStore): StockItem[] => (state.exceptions[store.storeId] ?? []),
);

export const selectShelfTalkersPaginationData = createSelector(
  selectShelfTalkersState,
  selectSelectedStore,
  (state: ShelfTalkersState, store: IStore): IPaginationData => (state.paginationData[store.storeId]
  ),
);

export const selectShelfTalkersSortMethodForStoreId = createSelector(
  selectShelfTalkersState,
  selectSelectedStore,
  (state: ShelfTalkersState, store: IStore): string => (state.sortMethod[store.storeId] ?? ''),
);

export const selectPrintOtherShelfTalkers = createSelector(
  selectShelfTalkersState,
  selectSelectedStore,
  selectLineColoursBySelectedStore,
  (state: ShelfTalkersState, store: IStore, lineColours: TLineColour): IAutoOrderAddStockItems => ({
    stockItems: state.otherStockItems[store.storeId],
    paginationData: state.otherStockItemsPaginationData[store.storeId],
    facetCounts: state.otherStockItemsFacetCounts[store.storeId],
    filter: state.otherStockItemsFilters[store.storeId],
    lineColour: lineColours,
  }),
);

export const selectSuppliersFromSharedAsSearchableField = createSelector(
  selectSuppliersByUserSelectedStore,
  (suppliers: Record<string, ISupplier>): ISearchableFields => {
    const searchableFields: ISearchableFields = {};
    for (const supplierId in suppliers) {
      const supplier = suppliers[supplierId];
      searchableFields[supplierId] = {
        name: supplier.name,
        value: false,
      };
    }
    return searchableFields;
  },
);


export const selectIsShelfTalkersTagLoading = createSelector(
  selectShelfTalkersState,
  (state: ShelfTalkersState): boolean => (state.isRemoveTagsLoading),
);

export const selectIsShelfTalkersDataLoading = createSelector(
  selectShelfTalkersState,
  (state: ShelfTalkersState): boolean => state.isStockItemsLoading || state.isExceptionsLoading,
);

export const selectIsShelfTalkersStockItemsLoading = createSelector(
  selectShelfTalkersState,
  (state: ShelfTalkersState): boolean => state.isStockItemsLoading,
);

export const selectIsShelfTalkersExceptionsLoading = createSelector(
  selectShelfTalkersState,
  (state: ShelfTalkersState): boolean => state.isExceptionsLoading,
);

export const selectShelfTalkerSettings = createSelector(
  selectShelfTalkersState,
  selectSelectedStore,
  (state: ShelfTalkersState, store: IStore): IFirebaseLabelDesignsData => (state.shelfTalkerSettings[store.storeId]),
);

export const selectIsShelfTalkerLayoutsLoading = createSelector(
  selectShelfTalkersState,
  (state: ShelfTalkersState): boolean => state.isLayoutsLoading,
);

export const selectShelfTalkerLayoutsLoadFailed = createSelector(
  selectShelfTalkersState,
  (state: ShelfTalkersState): boolean => state.layoutsLoadFailed,
);


